import type { TreeNode } from 'tree-model';

import { ISG_FOLDER_EXTERNAL_ID } from '@iconik-io/core/src/constants/isg';
import type { AssetsCollectionElasticSchemaWithIdNullable } from '@iconik-io/iconik-api/src/services/assets';
import type { SearchItemEntity } from '@iconik-io/shared-lib/src/redux/entities/normalized/search_item';

import type { TreeReducerModel } from '../ducks/tree/types';

export const isCollectionMappedToStorage = (
  collection: Partial<AssetsCollectionElasticSchemaWithIdNullable> | undefined,
): boolean =>
  Boolean(collection?.storage_id) ||
  collection?.external_id === ISG_FOLDER_EXTERNAL_ID;

export const shouldShowCreateCollectionForm = (
  collectionId: string | undefined,
  canWriteCollections: boolean,
  canCreateCollections: boolean,
  canCreateRootCollections: boolean,
): boolean => {
  let show = false;
  if (collectionId && canWriteCollections && canCreateCollections) {
    show = true;
  } else if (!collectionId && canWriteCollections && canCreateRootCollections) {
    show = true;
  }
  return show;
};

export const getParentCollectionsFromTree = (
  obj: TreeNode<TreeReducerModel> | undefined,
): Partial<SearchItemEntity[]> | [] => {
  if (!obj) {
    return [];
  }
  const result: SearchItemEntity[][] = [];
  const iterate = (
    treeNode: TreeNode,
    searchItem: SearchItemEntity[],
  ): SearchItemEntity[] | undefined => {
    const parent: TreeNode | undefined = treeNode.parent;
    if (parent) {
      return iterate(parent, searchItem.concat(treeNode.model));
    }
    result.unshift(searchItem);
  };
  iterate(obj, []);
  return result.flat();
};
